import validator from "validator";

export const isValidUsername = (aUserName, isMandatory = false) => {
  if (aUserName) {
    return validator.matches(aUserName, /^[a-zA-Z0-9_@+.-]{10,32}$/);
  }

  return !isMandatory;
}

export const isValidPassword = (aPassword, isMandatory = false) => {
  if (aPassword) {
    // Adapted from Java format: ^[a-zA-Z0-9_@`[.][+][|][-]]{18,32}$
    return validator.matches(aPassword, /^[a-zA-Z0-9_@`|+.-]{18,32}$/);
  }

  return !isMandatory;
}

export const isValidPhone = (aPhoneNumber, isMandatory = false) => {
  if (aPhoneNumber) {
    return validator.isMobilePhone(aPhoneNumber) || validator.isNumeric(aPhoneNumber);
  }

  return !isMandatory;
}

export const isValidPersonName = (aName, isMandatory = false) => {
  if (aName) {
    return validator.matches(aName, /^[a-zA-Z0-9_+.!() -]{1,26}$/);
  }

  return !isMandatory;
}

export const isValidAccountName = (anAccountName, isMandatory = false) => {
  if (anAccountName) {
    return validator.matches(anAccountName, /^[a-zA-Z0-9_+.!() -]{1,50}$/);
  }
  
  return !isMandatory;
}

export const isValidEmail = (anEmailAddress, isMandatory = false) => {
  if (anEmailAddress) {
    return validator.isEmail(anEmailAddress);
  }

  return !isMandatory;
}

export default function useValidation() {
  return {
  }      
}
